const state = {
    labels: [],
    language: window.location.href.indexOf("fr") != -1 ? "fr" : "en",
}

const getters = {}
const mutations = {
    updateLanguage(state, language) {
        state.language = language;
    },

    populateTranslationLabels(state, data) {
        state.labels = data
    }
}

const actions = {}

module.exports = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};